import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/primitives";

export function Pagination({
  page,
  limit,
  total,
  onChange,
}: {
  page: number;
  limit: number;
  total: number;
  onChange: (page: number) => void;
}) {
  const from = total === 0 ? 0 : page * limit + 1;
  const to = Math.min((page + 1) * limit, total);

  return (
    <div className="flex items-center justify-between pt-3 text-sm text-muted-foreground">
      <span>
        {from}–{to} / {total} toplam
      </span>
      <div className="flex gap-2">
        <Button
          variant="secondary"
          size="sm"
          disabled={page === 0}
          onClick={() => onChange(page - 1)}
        >
          <ChevronLeft className="size-4" />
          Önceki
        </Button>
        <Button
          variant="secondary"
          size="sm"
          disabled={to >= total}
          onClick={() => onChange(page + 1)}
        >
          Sonraki
          <ChevronRight className="size-4" />
        </Button>
      </div>
    </div>
  );
}
